<template>
  <div class="ivan-setting-page anCore-fill" v-loading="loading">
    <div class="row">
      <div class="form-group col-sm-4 has-feedback">
        <div class="input-group">
          <span class="input-group-addon"><span>类别名称</span></span>
          <input class="form-control" v-model="keyWord" @input="resetPage">
          <span class="fa fa-search form-control-feedback" aria-hidden="true" />
          <span class="sr-only">-</span>
        </div>
      </div>
    </div>

    <div class="table-area">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th style="min-width:88px;">类别名称</th>
            <th style="min-width:88px;">是否采样</th>
            <th style="min-width:88px;">监测归类</th>
            <th style="min-width:120px;">监测编码</th>
            <th style="min-width:150px;">监测的项目类型</th>
            <th style="width:110px;text-align:center;">
              <button type="button" class="btn btn-success btn-sm" @click="onReadonly">
                <i class="fa fa-plus" />&nbsp;新增
              </button>
            </th>
          </tr>
        </thead>
        <tbody v-if="filtered.length">
          <tr
            v-for="row in filtered"
            :key="row.ProjectTypeID"
            :class="{ 'anCore-item-active': selectedId === row.ProjectTypeID }"
            @click="selectRow(row.ProjectTypeID)"
          >
            <td>{{ row.ProjectType }}</td>
            <td><span>{{ row.NoPickWfTask ? '否' : '是' }}</span></td>
            <td>
              <span>{{ row.IsEnvironQuality ? '环境质量' : (row.IsPollutionSource ? '污染源' : '') }}</span>
            </td>
            <td>{{ row.ProjectCode }}</td>
            <td>
              <div>
                <span v-for="(s, i) in (row.InspectTypeList || [])" :key="s.SubTypeID || i">
                  {{ s.InspectSubType }};
                </span>
              </div>
            </td>
            <td>
              <button type="button" class="btn btn-link btn-sm" title="编辑" @click.stop="onReadonly">
                <i class="fa fa-edit" />
              </button>
              <button type="button" class="btn btn-link btn-sm" title="删除" @click.stop="onReadonly">
                <i class="fa fa-trash-o text-muted" />
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="6">
              <div class="text-center text-muted" style="padding:10px 0;">当前暂无数据</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { loadIvanSyncJson } from '@/utils/ivanSync'
import ivanSettingList from '@/mixins/ivanSettingList'

export default {
  name: 'ProjectTypeSetting',
  mixins: [ivanSettingList],
  data() {
    return {
      loading: false,
      list: [],
      keyWord: ''
    }
  },
  computed: {
    filtered() {
      const kw = String(this.keyWord || '').trim().toLowerCase()
      if (!kw) return this.list
      return this.list.filter(row => {
        const types = (row.InspectTypeList || []).map(s => s.InspectSubType).join(' ')
        return `${row.ProjectType || ''} ${row.ProjectCode || ''} ${types}`.toLowerCase().indexOf(kw) >= 0
      })
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const data = await loadIvanSyncJson('project_type.json')
        this.list = (data && data.projectTypeGrid && data.projectTypeGrid.List) || []
      } catch (e) {
        this.$message.error(e.message || '加载监测类别失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.ivan-setting-page {
  height: 100%;
  padding: 8px 12px 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.ivan-setting-page > .row { margin: 0; flex: 0 0 auto; }
.table-area {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  height: calc(100% - 60px);
}
.table-area >>> tbody tr { cursor: pointer; }
.has-feedback .form-control-feedback {
  pointer-events: none;
  z-index: 3;
  right: 0;
  line-height: 34px;
  height: 34px;
}
</style>
